import React__default, { forwardRef, useRef } from 'react';
import * as RadixNavigationMenuPrimitive from '@radix-ui/react-navigation-menu';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';
import Box from '../Box/Box.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A collection of links for navigating websites.
 */
const NavigationMenu = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  sx: sxProp,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);

  // const mergedProps: NavigationMenuRootProps = {
  //   ...props
  //   // Add or modify props here if needed
  // }

  return /*#__PURE__*/React__default.createElement(Box, {
    sx: sxProp
  }, /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Root, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-root` : undefined,
    className: UNSAFE_className
  }, props), children));
});

/**
 * Signifies a submenu. Use it in place of the root part when nested to create a submenu.
 */
const Sub = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Sub, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-sub` : undefined,
    className: UNSAFE_className
  }, props), children);
});

/**
 * Contains the top level menu items.
 */
const List = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.List, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-list` : undefined,
    className: UNSAFE_className
  }, props), children);
});

/**
 * A top level menu item, contains a link or trigger with content combination.
 */
const Item = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Item, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-item` : undefined,
    className: UNSAFE_className
  }, props), children);
});

/**
 * The button that toggles the content.
 */
const Trigger = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Trigger, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-trigger` : undefined,
    className: UNSAFE_className
  }, props), children);
});

/**
 * Contains the content associated with each trigger.
 */
const Content = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Content, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-content` : undefined,
    className: UNSAFE_className
  }, props), children);
});

/**
 * A navigational link.
 */
const Link = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Link, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-link` : undefined,
    className: UNSAFE_className
  }, props), children);
});

/**
 * An optional indicator element that renders below the list, is used to highlight the currently active trigger.
 */
const Indicator = /*#__PURE__*/forwardRef(({
  children,
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Indicator, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-indicator` : undefined,
    className: UNSAFE_className
  }, props), children);
});

/**
 * An optional indicator element that renders below the list, is used to highlight the currently active trigger.
 */
const Viewport = /*#__PURE__*/forwardRef(({
  testId,
  UNSAFE_className,
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React__default.createElement(RadixNavigationMenuPrimitive.Viewport, _extends({
    ref: innerRef,
    "data-testid": testId ? `${testId}-navigation-menu-viewport` : undefined,
    className: UNSAFE_className
  }, props));
});

// exports
NavigationMenu.displayName = 'NavigationMenu';
Sub.displayName = 'Sub';
List.displayName = 'List';
Item.displayName = 'Item';
Trigger.displayName = 'Trigger';
Content.displayName = 'Content';
Link.displayName = 'Link';
Indicator.displayName = 'Indicator';
Viewport.displayName = 'Viewport';
var NavigationMenu$1 = Object.assign(NavigationMenu, {
  Sub,
  List,
  Item,
  Trigger,
  Content,
  Link,
  Indicator,
  Viewport
});

export { NavigationMenu$1 as default };
